(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestDetailController', AgentRequestDetailController);

    AgentRequestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentRequest', 'Company'];

    function AgentRequestDetailController($scope, $rootScope, $stateParams, entity, AgentRequest, Company) {
        var vm = this;

        vm.agentRequest = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentRequestUpdate', function (event, result) {
            vm.agentRequest = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
